import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { ExternalAuthBootstrapModule } from './app/external-bootstrap/external-auth-bootstrap.module';
import { shouldBootstrapExternalAuth } from './app/external-bootstrap/external-auth-bootstrap.utils';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const bootstrapModule = shouldBootstrapExternalAuth(window.location.pathname, window.location.search)
  ? ExternalAuthBootstrapModule
  : AppModule;

platformBrowserDynamic().bootstrapModule(bootstrapModule)
  .catch(err => console.error(err));
